<div class="applications-wrapper">

  <!-- Header -->
  <div class="applications-header">
    <h1 class="applications-title">Alberici AI</h1>

    <!--<button class="edit-button">
      Edit
    </button>-->
  </div>

  <!-- Applications -->
  <div class="applications-grid">

    <a target="_blank" href="https://m365.cloud.microsoft/chat/?titleId=T_6406ae30-6440-ba51-970d-c80395560b9e" class="application-item">
      <div class="application-icon icon-red">
        <!--<i class="bi bi-clock"></i>-->
        <img src="../assets/sop_hub.png" width="30" />
      </div>
      <div class="application-name">
        SOP Hub
      </div>
    </a>

  </div>-

</div>
